var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviouscarouselControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(-180 16 16)",
    fill: "#CE8F68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.294 10L19 10.706L14.0595 15.6465C13.9658 15.7403 13.9131 15.8674 13.9131 16C13.9131 16.1326 13.9658 16.2598 14.0595 16.3535L18.9915 21.2845L18.2845 21.9915L13.3535 17.0605C13.0723 16.7792 12.9143 16.3978 12.9143 16C12.9143 15.6023 13.0723 15.2208 13.3535 14.9395L18.294 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(22 22) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviouscarouselControls);
export default __webpack_public_path__ + "static/media/Previouscarousel-controls.f64b4fd48a5c765557659facfbe3158c.svg";
export { ForwardRef as ReactComponent };